import { decode } from "html-entities";
import { CurrencyType } from "./constants";
import numeral from "numeral";

export function comma(x) {
  return numeral(x).format("0,0,0.00");
}

/**
 *
 * @param {number} amount
 * @param {string} currency
 * @returns string
 */
export const parseCurrency = (amount, currency) => {
  if (currency === "NGN") return `${CurrencyType.ngn} ${comma(amount)}`;
  if (currency === "USD") return `${CurrencyType.usd} ${comma(amount)}`;
  return " " + comma(amount);
};
